import { render, staticRenderFns } from "./ProductCategorySelector.vue?vue&type=template&id=55b57fe9&scoped=true"
import script from "./ProductCategorySelector.vue?vue&type=script&lang=js"
export * from "./ProductCategorySelector.vue?vue&type=script&lang=js"
import style0 from "./ProductCategorySelector.vue?vue&type=style&index=0&id=55b57fe9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b57fe9",
  null
  
)

export default component.exports